declare namespace $ {

	type $mol_view__sub_shm_hitalama_guide_panel_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['heading'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__hint_shm_hitalama_guide_panel_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__enabled_shm_hitalama_guide_panel_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['editable'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__checked_shm_hitalama_guide_panel_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['editing'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_guide_panel_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['Edit_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__hint_shm_hitalama_guide_panel_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_panel_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_guide_panel_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_guide_text__text_shm_hitalama_guide_panel_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['text'] >
		,
		ReturnType< $shm_hitalama_guide_text['text'] >
	>
	type $shm_hitalama_guide_text__page_uri_shm_hitalama_guide_panel_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['page_uri'] >
		,
		ReturnType< $shm_hitalama_guide_text['page_uri'] >
	>
	type $mol_page__title_shm_hitalama_guide_panel_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__minimal_width_shm_hitalama_guide_panel_12 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_page['minimal_width'] >
	>
	type $mol_page__title_content_shm_hitalama_guide_panel_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_hitalama_guide_panel_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_guide_panel_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_hitalama_guide_panel_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['crumb_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_guide_panel_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['crumb_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_hitalama_guide_panel_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_guide_editor__catalog_shm_hitalama_guide_panel_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['catalog'] >
		,
		ReturnType< $shm_hitalama_guide_editor['catalog'] >
	>
	type $shm_hitalama_guide_editor__id_shm_hitalama_guide_panel_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['selected'] >
		,
		ReturnType< $shm_hitalama_guide_editor['id'] >
	>
	type $shm_hitalama_guide_editor__opened_shm_hitalama_guide_panel_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_panel['editing'] >
		,
		ReturnType< $shm_hitalama_guide_editor['opened'] >
	>
	export class $shm_hitalama_guide_panel extends $mol_book2 {
		guide_pages( ): readonly($mol_view)[]
		title( ): string
		heading( ): readonly($mol_view_content)[]
		Header_title( ): $mol_view
		editable( ): boolean
		editing( next?: boolean ): boolean
		Edit_icon( ): $mol_icon_pencil
		Edit( ): $mol_check_icon
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		text( ): string
		page_uri( id: any): string
		Text( ): $shm_hitalama_guide_text
		crumb_arg( id: any): Record<string, any>
		crumb_title( id: any): string
		catalog( ): $shm_hitalama_guide_catalog
		selected( ): string
		section( ): string
		param( ): string
		menu_title( ): string
		pages( ): ReturnType< $shm_hitalama_guide_panel['guide_pages'] >
		Page( ): $mol_page
		Crumb( id: any): $mol_link
		Header_label( ): $mol_view
		Editor( ): $shm_hitalama_guide_editor
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map